module.exports = __webpack_public_path__ + "assets/img/files-my-media.f16fbb09.svg";